/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Academy_Status_AssignedInputs */

const en_academy_status_assigned = /** @type {(inputs: Academy_Status_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assigned`)
};

const ja_academy_status_assigned = /** @type {(inputs: Academy_Status_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`割り当て済`)
};

const fr_academy_status_assigned = /** @type {(inputs: Academy_Status_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assigné`)
};

const de_academy_status_assigned = /** @type {(inputs: Academy_Status_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugewiesen`)
};

/**
* | output |
* | --- |
* | "Assigned" |
*
* @param {Academy_Status_AssignedInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const academy_status_assigned = /** @type {((inputs?: Academy_Status_AssignedInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Academy_Status_AssignedInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_academy_status_assigned(inputs)
	if (locale === "ja") return ja_academy_status_assigned(inputs)
	if (locale === "fr") return fr_academy_status_assigned(inputs)
	return de_academy_status_assigned(inputs)
});